import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-cfa3a794"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "popularAccountsBox"
}
const _hoisted_2 = { class: "mt-10" }
const _hoisted_3 = { class: "anchor-tag four-a-color" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"padding-left":"4px","padding-right":"4px","color":"#aaa"} }, " | ", -1))
const _hoisted_5 = { class: "table pa-table" }
const _hoisted_6 = { class: "popular-account-head" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "hidden-xs" }, "ACCOUNT TYPE", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "HOW THEY COMPARE", -1))
const _hoisted_9 = { class: "view-all-link" }
const _hoisted_10 = { href: "#rates" }
const _hoisted_11 = {
  key: 1,
  class: "popularAccountsBox"
}
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<div class=\"row\" data-v-cfa3a794><div class=\"col-12 col-sm colWithoutLeftPadding\" data-v-cfa3a794><div class=\"firstLine da-skeleton-loader\" data-v-cfa3a794></div><div class=\"secondLine da-skeleton-loader\" data-v-cfa3a794></div><div class=\"firstLine da-skeleton-loader\" data-v-cfa3a794></div><div class=\"secondLine da-skeleton-loader\" data-v-cfa3a794></div><div class=\"firstLine da-skeleton-loader\" data-v-cfa3a794></div><div class=\"secondLine da-skeleton-loader\" data-v-cfa3a794></div><div class=\"secondLine da-skeleton-loader\" data-v-cfa3a794></div></div></div>", 1)
const _hoisted_13 = [
  _hoisted_12
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_how_da_gets_paid = _resolveComponent("how-da-gets-paid")!
  const _component_ad_disclosure_tooltip = _resolveComponent("ad-disclosure-tooltip")!
  const _component_apy_label = _resolveComponent("apy-label")!
  const _component_popular_account = _resolveComponent("popular-account")!

  return (_ctx.itemsRendered)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.title), 1),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_how_da_gets_paid),
          _createTextVNode(),
          _hoisted_4,
          _createTextVNode(),
          _createVNode(_component_ad_disclosure_tooltip)
        ]),
        _createElementVNode("table", _hoisted_5, [
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", _hoisted_6, [
              _createElementVNode("th", null, [
                _createVNode(_component_apy_label)
              ]),
              _hoisted_7,
              _hoisted_8
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.popularAccountsWithAd, (ad) => {
              return (_openBlock(), _createBlock(_component_popular_account, {
                key: ad.id,
                popularAccount: ad
              }, null, 8, ["popularAccount"]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("a", _hoisted_10, "View all " + _toDisplayString(_ctx.bank.Name) + " rates »", 1)
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13))
}